export const PERMISSIONS = {
  SETTINGS: {
    ACTIVITY_TYPES: {
      VIEW: "ACTVACT",
    },

    APPEARANCE: {
      VIEW: "APRNCEVIEW",
    },

    CONTACTS: {
      VIEW: "CONTVCONT",
    },

    DESIGNATION: {
      VIEW: "DESGDSGV",
      CREATE: "DESGDSGC",
      EDIT: "DESGDSGE",
      DELETE: "DESGDSGD",
    },

    INTEGRATION: {
      VIEW: "INTGVIEW",
      EDIT: "INTGEDIT",
    },

    LEAD_STAGE: {
      VIEW: "LEADSTGSTGV",
      CREATE: "LEADSTGSTGC",
      EDIT: "LEADSTGSTGE",
      DELETE: "LEADSTGSTGD",
    },

    NOTIFICATION_MANAGEMENT: {
      VIEW: "NOTIFSETTINGVIEW",
      EDIT: "NOTIFSETTINGEDIT",
    },

    ROLE: {
      VIEW: "ROLEROV",
      CREATE: "ROLEROC",
      EDIT: "ROLEROE",
      DELETE: "ROLEROD",
      VIEW_PERMISSIONS: "ROLEROVP",
      EDIT_PERMISSIONS: "ROLEROEP",
    },

    RULE: {
      VIEW: "RULERV",
      CREATE: "RULERC",
      EDIT: "RULERE",
      DELETE: "RULERD",
      ACTIVATE_DEACTIVATE: "RULERADS",
    },

    SETTINGS_CONFIGURATION: {
      VIEW: "STNGSTNGView",
    },

    TAGS_SOURCE: {
      VIEW: "TASVTAS",
    },

    TEAM: {
      VIEW: "TEAMTMV",
      CREATE: "TEAMTMC",
      EDIT: "TEAMTME",
      DELETE: "TEAMTMD",
    },

    TEMPLATE: {
      VIEW: "TMPTMPV",
      CREATE: "TMPTMPC",
      EDIT: "TMPTMPE",
      DELETE: "TMPTMPD",
    },

    USER: {
      VIEW: "USRUSRV",
      CREATE: "USRUSRC",
      EDIT: "USRUSRE",
      DELETE: "USRUSRD",
      ACTIVATE_DEACTIVATE: "USRUSRADS",
    },
  },

  DASHBOARD: {
    VIEW: "DASDASView",
    GLOBAL_SEARCH: "DASGBLSCH",
  },

  LEADS: {
    COMMUNICATION: {
      CALL: "COMMCL",
      SMS: "COMMSMS",
      EMAIL: "COMMEML",
      // WHATSAPP: "COMMWTSP",
    },

    FOLLOW_UPS: {
      VIEW: "FUPSVFUP",
      CREATE: "FUPSCFUP",
      EDIT: "FUPSEFUP",
      DELETE: "FUPSDFUP",
    },

    LEAD: {
      VIEW: "LEADLEADView",
      MANAGE_DROPDOWN: "LEADMGD",
    },

    LEAD_IMPORT: {
      DOWNLOAD_TEMPLATE: "LIDWNT",
      UPLOAD_EXCEL: "LIUEXL",
    },

    LEAD_EXPORT: {
      DOWNLOAD: "LELDN",
    },

    MANAGE_LEAD: {
      VIEW_DETAILS: "MLLVD",
      CREATE: "MLLC",
      EDIT: "MLLE",
      DELETE: "MLLD",
      ASSIGN: "MLASGN",
      CONVERT_TO_JOB: "MLCTJ",
    },
  },

  JOBS: {
    JOB: {
      VIEW: "JBJOBView",
      MANAGE_DROPDOWN: "JBMGD",
      TRADE_SUPPLIER_TAB: "JBJOB_VIEW_TRADE_SUPPLIER_TAB",
      CONTRACTOR_BOYS_TAB: "JBJOB_VIEW_CONTRACTOR_BOYS_TAB",
      TEAM_CALENDAR: "JBJBVTCAL",
    },

    MANAGE_JOB: {
      VIEW: "MGJBJV",
      CREATE: "MGJBJC",
      EDIT: "MGJBJE",
      DELETE: "MGJBJD",
      CREATESCHEDULE: "MGJBCST",
      EDITSCHEDULE: "MGJBEST",
      EXPORTSCHEDULE: "MGJBEXST",
      DELETESCHEDULE: "MGJBDST",
      EDIT_SELF_ASSIGNED_TASK: "MGJBEDSETKS",
      MANAGE_STATUS: "MGJBMJBST",
      VIEW_DRAFT_TASKS: "JBVDRFTKS",
      COMPLETE_ANY_TASK: "JBCANCOMANTSK",
      COMPLETE_TRADE_WORKER_TASK: "JBCANCOMTRDWRK",
    },

    WORKER_GROUP: {
      VIEW: "JBVIEWGROUP",
      CREATE: "JBCREATEGROUP",
      UPDATE: "JBUPDATEGROUP",
      DELETE: "JBDELETEGROUP",
    },
  },

  REPORTING: {
    VIEW: "RPTRPTView",

    LEAD_ALLOCATION: {
      VIEW: "LALAV",
      EXPORT: "LALAE",
    },

    LEAD_SOURCE: {
      VIEW: "LSRLSRV",
      EXPORT: "LSRLSRE",
    },

    LEAD_STATUS: {
      VIEW: "LSTLSTV",
      EXPORT: "LSTLSTE",
    },
  },

  FORMS: {
    FORM_BUILDER: {
      VIEW: "FBVF",
      CREATE: "FBCF",
      EDIT: "FBEF",
      DELETE: "FBDF",
    },

    FORM_DESK: {
      VIEW: "FDFDView",
    },

    FORM_EMBEDDING: {
      MANAGE_WEBSITE: "FEMWS",
      VIEW_EMBED_CODE: "FEVEC",
    },

    FORM_TEMPLATE: {
      VIEW: "FTVT",
      USE_TEMPLATE: "FTUT",
    },
  },

  WHS: {
    VIEW: "WHSWHSView",
    MANAGE_DROPDOWN: "WHSMGD",

    CONTRACTOR: {
      VIEW: "CONCONV",
      EDIT: "CONCONE",
      DELETE: "CONCOND",
    },

    INCIDENT_REPORT: {
      VIEW: "INRINRV",
      EDIT: "INRINRE",
      DELETE: "INRINRD",
    },

    SIGN_IN_OUT: {
      VIEW: "SISOSISOV",
      GENERATE_QR: "SISOGNQR",
    },

    TOOLBOX_TALKS: {
      VIEW: "TBTBV",
      EDIT: "TBTBE",
    },

    VEHICLE: {
      // NOTE: the backend builds each permission's code as ModuleConstant + PermissionConstant
      // (see ValidateUser.sql) — the Vehicle module's constant is "VHC", so these must stay
      // double-prefixed even though it looks redundant.
      VIEW_VEHICLE: "VHCVHCV",
      EDIT_VEHICLE: "VHCVHCE",
      REMOVE_VEHICLE: "VHCVHCRM",
      REGISTER_VEHICLE: "VHCVHCR",
      VIEW_ASSIGNED_VEHICLE: "VHCASSVEH",

      VIEW_CHECKLIST: "VHCVCV",
      EDIT_CHECKLIST: "VHCVCE",
      DELETE_CHECKLIST: "VHCVCD",
    },
  },
};